import { render } from "./DamageForm.vue?vue&type=template&id=b6c224b0"
import script from "./DamageForm.vue?vue&type=script&lang=js"
export * from "./DamageForm.vue?vue&type=script&lang=js"
script.render = render

export default script